module.exports = __webpack_public_path__ + "img/image-04.91583bac.svg";